<template>

  <rpm-card-list
      title="Colaboradores"
      :data="collaborators"
      :loading="loading"
      :pagination="pagination"
      @change-page="getCollaborators"
      grid-class="lg:grid-cols-2 grid-cols-1 gap-6"
  >
    <template #functions>
      <section class="w-full flex flex-row-reverse">
        <rpm-button
            class="w-6 h-6 rounded"
            font-size="text-sm"
            icon="fa-solid fa-plus"
            @click="modalOpen = true"
        ></rpm-button>
      </section>
    </template>
    <template #search>
      <section class="grid md:grid-cols-2 grid-cols-1 gap-x-6 gap-y-3 w-full">
        <rpm-input
            placeholder="Nome, matrícula, cpf..."
            v-model="searchForm.term"
        ></rpm-input>

        <rpm-input
            type="select"
            placeholder="Organização"
            v-model="searchForm.organization_id"
            :options="[{ id:'', name:'' }].concat(organizations)"
            optionLabel="name"
            optionValue="id"
        ></rpm-input>
      </section>
    </template>

    <template #badges="{ item }">
      <badge class="bg-sky-500 capitalize">{{ item.function }}</badge>
    </template>

    <template #actions="{ item }">
      <rpm-button
          color="transparent"
          icon="fa-solid fa-square-up-right"
          tooltip-text="informações"
          :to="{ name: 'PeopleShow', params: { id: item.personid } }"
      ></rpm-button>

      <rpm-button
          color="transparent"
          icon="fa-solid fa-key"
          tooltip-text="reiniciar senha"
          @click="openModalResetPassword(item)"
          v-if="item.email"
      ></rpm-button>
    </template>

    <template #info="{ item }">
      <span class="font-bold text-lg"> {{ item.name }} </span>
      <span v-if="item.organization" class="text-sm">
        <span class="font-bold"> Organização: </span>
        <span class="font-semibold capitalize"> {{ item.organization?.name }} </span>
      </span>
      <span class="text-sm"> <b>Usuário:</b> {{ item.username }} </span>
      <span class="text-sm"> <b>Matrícula:</b> {{ item.registration_id }} </span>
    </template>
  </rpm-card-list>

  <rpm-modal class="flex flex-col gap-10" :open="modalOpen">
    <create-collaborator @save="addedCollaborator" @close="modalOpen = false"></create-collaborator>
  </rpm-modal>
  <rpm-modal :open="modalConfirmResetPassword" v-if="selectedCollaborator">
    <p>Reiniciar senha para: {{selectedCollaborator.name}}</p>
    <section class="flex flex-row justify-center gap-6 mt-4">
      <rpm-button @click="resetPassword" label="Salvar" :loading="loadingPasswordReset"/>
      <rpm-button @click="modalConfirmResetPassword = false" label="Fechar" color="gray"/>
    </section>
  </rpm-modal>

</template>

<script>

import {request} from "#repositories/repository";
import collaboratorRepository from "#repositories/collaboratorRepository";
import personRepository from "#repositories/personRepository";
import organizationsRepository from "#repositories/organizationsRepository";
import RpmCardList from "#components/RpmCardList.vue";
import Badge from "#components/Badge.vue";
import CreateCollaborator from '../modals/create.vue'
import RpmModal from "#components/RpmModal.vue";

export default {
  name: 'Collaborators',
  components: {
    RpmCardList,
    Badge,
    CreateCollaborator,
    RpmModal
  },
  data() {
    return {
      loading: false,
      collaborators: [],
      organizations: [],
      searchTimer: null,
      searchForm: {
        organization_id: this.$route.query.organization_id,
        term: this.$route.query.term
      },
      pagination: {
        page: this.$route.query.page ?? 1,
        per_page: 12,
        last_page: 0,
        links: []
      },
      modalOpen: false,
      modalConfirmResetPassword: false,
      selectedCollaborator: null,
      loadingPasswordReset: false
    };
  },
  methods: {
    async getCollaborators(page = 0) {
      if (page !== 0) this.pagination.page = page;

      this.loading = true;

      this.$router.push({
        path: this.$route.path,
        query: {
          page: this.pagination.page,
          term: this.searchForm.term,
          organization_id: this.searchForm.organization_id
        }
      });

      this.collaborators = request.pagination(
          await collaboratorRepository.getCollaborators({
            organization_id: this.searchForm.organization_id,
            term: this.searchForm.term,
            ...this.pagination
          }),
          this.pagination
      );

      this.loading = false;
    },
    openModalResetPassword(item){
      this.selectedCollaborator = item
      this.modalConfirmResetPassword = true
    },
    resetPassword(){
      this.loadingPasswordReset = true
      personRepository.changePassword({
        email: this.selectedCollaborator.email,
        cpf_cnpj: this.selectedCollaborator.cpf_cnpj
      }).then((response) => {
        this.$notify('Email de recuperação enviado.', 'success')
        this.modalConfirmResetPassword = false
      }).catch((error) => {
        this.$notify(error.response.data, 'error')
      }).finally(() => {
        this.loadingPasswordReset = false
      })
    },
    searchCollaborators() {
      clearTimeout(this.searchTimer);

      this.searchTimer = setTimeout(() => {
        this.pagination.page = 1;
        this.getCollaborators();
      }, 750);
    },
    addedCollaborator(){
      this.modalOpen = false
      this.$notify('Colaborador adicionado com sucesso', 'success')
      this.getCollaborators();
    }
  },
  watch: {
    'searchForm.organization_id': 'searchCollaborators',
    'searchForm.term': 'searchCollaborators'
  },
  async mounted() {
    this.getCollaborators();
    this.organizations = (await organizationsRepository.getOrganizations()).data;
  }
}
</script>
